/* Our Story page: gentle reveal-on-scroll, as in the original GemPages block.
   Every story section loads this file, so it guards against running twice.
   In the theme editor everything is shown at once, so nothing is hidden
   while Craig is editing. */
(function () {
  if (window.swStoryReveal) return;
  window.swStoryReveal = true;

  if (window.Shopify && window.Shopify.designMode) return;
  if (!('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('sw-os-js');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en, i) {
      if (!en.isIntersecting) return;
      en.target.style.transitionDelay = Math.min(i, 4) * 70 + 'ms';
      en.target.classList.add('is-in');
      io.unobserve(en.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  document.querySelectorAll('.sw-os .sw-reveal').forEach(function (el) { io.observe(el); });
})();
